import { render } from "./TheFastOrderSuccess.vue?vue&type=template&id=5c23d8f8"
import script from "./TheFastOrderSuccess.vue?vue&type=script&lang=js"
export * from "./TheFastOrderSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__